export const DEFAULT = {
  intervalTime: 400,
  hideAniTime: 300,
  showAniTime: 300,
  showTime: 400,
  randomTime: 300,
  width: 241,
  height: 206
};



// WEBPACK FOOTER //
// ./packages/dof-lottery-rain/libs/config.js